export const getCookie = (name: string): string | null => {
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return v ? decodeURIComponent(decodeURI(v[2])) : null;
};

export const setCookie = (name: string, value: string, days: number = 1): void => {
  const d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);

  const full = document.domain.match(/[^.]*\.[^.]*$/);
  const domain = `domain=${full ? full[0] : ""};`;

  document.cookie = `${name}=${value};path=/;${domain}expires=${d.toUTCString()}`;
};

export const deleteCookie = (name: string): void => {
  setCookie(name, "", -1);
};
